import {
  ElementType,
  HtmlHTMLAttributes,
  PropsWithChildren,
  ReactNode,
} from 'react';
import { ICON_CIRCLE_STYLES } from '@sib/config';
import { cn } from '@sib/ui';
import { EmptyResults } from '@sib/ui/icons';

export interface NoTableDataProps
  extends PropsWithChildren,
    HtmlHTMLAttributes<HTMLDivElement> {
  Icon?: ElementType;
  title: string;
  description?: string;
  actions?: ReactNode;
  iconClassName?: string;
  descriptionClassName?: string;
}

export const NoTableData = ({
  Icon,
  title,
  description,
  children,
  className,
  actions,
  iconClassName,
  descriptionClassName,
}: NoTableDataProps) => (
  <div className="flex size-full items-center justify-center overflow-hidden rounded">
    <div
      className={cn(
        'relative box-border flex size-full flex-col items-center justify-center gap-y-7 rounded-sm py-20',
        className
      )}
    >
      {Icon ? (
        <div className={iconClassName}>
          <Icon className={cn(ICON_CIRCLE_STYLES, 'text-primary size-32')} />
        </div>
      ) : (
        <EmptyResults
          className={cn(ICON_CIRCLE_STYLES, 'text-primary size-32')}
          aria-hidden="true"
        />
      )}
      <div className="flex w-full flex-col items-center gap-y-4">
        <h3 className="text-primary text-center text-[28px] leading-[42px]">
          {title}
        </h3>
        {description && (
          <p
            className={cn(
              'text-muted-foreground max-w-md text-center text-[16px] leading-[22px] font-normal',
              descriptionClassName
            )}
          >
            {description}
          </p>
        )}
      </div>
      {actions && <div className="mt-4">{actions}</div>}
      {children}
    </div>
  </div>
);
